module.exports = __webpack_public_path__ + "img/48.c1be9955.jpg";